import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux/reducers/adminReducer";
import { persistor } from "../../../redux/configureStore";
import oktaConfig from "../../../configs/okta";

export default function AdminSettingScreen({ navigation }: any) {
  const admin = useSelector((state: any) => state.admin);
  const dispatch = useDispatch<any>();
  const logoutHandler = () => {
    dispatch(logout());
    persistor.purge();
    window.location.href = `${oktaConfig.api.redirectUri}/admin/login`;
  };

  return (
    <View style={styles.container}>
      <View style={{ flex: 1 }}>
        <View style={[styles.user, styles.row]}>
          <View style={styles.imgIconContainer}>
            <Image
              source={require("../../../assets/images/boy.png")}
              style={styles.userImg}
              resizeMode="contain"
            />
          </View>
          <View style={styles.justifyContent}>
            <Text style={styles.userName}>{admin?.email}</Text>
          </View>
        </View>

        <View style={styles.row}>
          <View style={styles.imgIconContainer}>
            <FontAwesome name="user" size={24} color="black" />
          </View>
          <View style={styles.justifyContent}>
            <Text
              style={styles.rowTitle}
              onPress={() =>
                navigation.navigate("AdminHelp", {
                  screen: "AdminAccountProfileSetting",
                })
              }
            >
              Account Settings
            </Text>
          </View>
        </View>

        <View style={styles.row}>
          <View style={styles.imgIconContainer}>
            <FontAwesome name="users" size={24} color="black" />
          </View>
          <View style={styles.justifyContent}>
            <Text
              style={styles.rowTitle}
              onPress={() =>
                navigation.navigate("AdminHome", {
                  screen: "AdminOrganizationalUsers",
                })
              }
            >
              User Management
            </Text>
          </View>
        </View>

        <View style={styles.row}>
          <View style={styles.imgIconContainer}>
            <FontAwesome name="building" size={24} color="black" />
          </View>
          <View style={styles.justifyContent}>
            <Text
              style={styles.rowTitle}
              onPress={() =>
                navigation.navigate("AdminHome", {
                  screen: "AdminOrganizations",
                })
              }
            >
              Organisation Settings
            </Text>
          </View>
        </View>
      </View>
      <View>
        <View style={styles.row}>
          <View style={[styles.imgIconContainer, { paddingRight: 0 }]}>
            <MaterialCommunityIcons name="logout" size={24} color="red" />
          </View>
          <View style={styles.justifyContent}>
            <Text style={styles.logoutTitle} onPress={() => logoutHandler()}>
              Sign Out
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  justifyContent: { justifyContent: "center" },
  container: { flex: 1, backgroundColor: "#fff" },
  row: { flexDirection: "row", paddingHorizontal: 12, paddingVertical: 15 },
  user: { borderBottomWidth: 1, borderBottomColor: "#F0F0F0" },
  userImg: { width: 28, height: 28, backgroundColor: "grey", borderRadius: 50 },
  userName: { fontWeight: "800" },
  rowTitle: { fontWeight: "500" },
  imgIconContainer: { paddingRight: 10, width: 35, alignItems: "center" },
  logoutTitle: { fontWeight: "500", fontSize: 16, color: "red" },
});
